import { useState } from 'react'

// Live element size via a callback ref (MUST stay a callback ref: the modal's
// Box mounts the stage a tick later, which a `[]`-effect would miss). React 19
// runs the cleanup returned from the ref.
export function useElementSize() {
  const [size, setSize] = useState({ height: null, width: null })

  function ref(element) {
    if (element) {
      function measure() {
        setSize(previous =>
          previous.height === element.clientHeight &&
          previous.width === element.clientWidth
            ? previous
            : { height: element.clientHeight, width: element.clientWidth }
        )
      }

      measure()

      const observer = new ResizeObserver(measure)

      observer.observe(element)

      return () => observer.disconnect()
    }
  }

  return [ref, size]
}
